module.exports = __webpack_public_path__ + "assets/9a104fa6471dd64a4b5b5c661d7ec16c.mp3";